import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class ExportListItem extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleSelection = event => {
    event.preventDefault();
    const selectedElementId = event.currentTarget.id;
    let clearExisting = true;
    let shiftKey = false;
    if (event.ctrlKey) {
      clearExisting = false;
    }
    if (event.shiftKey) {
      shiftKey = true;
    }
    this.props.handleSelection(selectedElementId, clearExisting, shiftKey);
  };
  render() {
    const { text, id, selected, type, pane } = this.props;
    const paneClass = `${pane}-items`;
    return (
      <li
        onMouseDown={this.handleSelection}
        id={id}
        className={selected ? 'active' : ''}
      >
        <a title={text} className={type === 'standard' ? `standard-base-items ${paneClass}` : `user-defined-base-items ${paneClass}`}>{text.toUpperCase()}</a>
      </li>
    );
  }
}

ExportListItem.propTypes = {
  handleSelection: PropTypes.func,
  text: PropTypes.string,
  id: PropTypes.string,
  selected: PropTypes.bool,
  type: PropTypes.string,
};
